import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

// import { API_URLS_BOARD, API_URLS_NOTA_COBRO } from '@/constants'

/* --------------------------------- ACTIONS -------------------------------- */


// const getNotasCobro = (context, params) => {
//     let url = API_URLS_NOTA_COBRO.baseUrl + API_URLS_NOTA_COBRO.getLatest //ANCHOR[id=ALL-DATA]
//     return axios.get(url, params).then(response => {
//         let notas_cobro = response.data
//         context.commit('setNotasCobro', notas_cobro)
//     }).catch((error) => {
//         console.log(error.response)
//     })
// }

const addItem = (context, item) => {

    context.commit('setItem', item);
}

const deleteItem = (context, index) => {
  context.commit('removeItem', index);
}


const addRow = (context, obj) => {
  context.commit('setRow', obj);
}

const editRow = (context, obj) => {
  context.commit('updateRow', obj);
}

const deleteRow = (context, obj) => {
  context.commit('removeRow', obj);
}

const addUser = (context, user) => {
  context.commit('setUser', user);
}

const addDestinatario = (context, destinatario) => {
  context.commit('setDestinatario', destinatario);
}

const deleteDestinatario = (context, index) => {
  context.commit('removeDestinatario', index);
}

const addReplyTo = (context, reply_to) => {
  context.commit('setReplyTo', reply_to);
}

const deleteReplyTo = (context, index) => {
  context.commit('removeReplyTo', index);
}



export default {
    // getNotasCobro,
    addItem,
    deleteItem,

    addRow,
    deleteRow,

    addUser,
    editRow,

    addDestinatario,
    deleteDestinatario,
    addReplyTo,
    deleteReplyTo
}
